module.exports = {
          srcSet: __webpack_public_path__ + "c5900cb7b3906cb216f9a6df647483e6-60.png"+" 60w",
          images:[ {path: __webpack_public_path__ + "c5900cb7b3906cb216f9a6df647483e6-60.png",width: 60,height: 60}],
          src: __webpack_public_path__ + "c5900cb7b3906cb216f9a6df647483e6-60.png",
          toString:function(){return __webpack_public_path__ + "c5900cb7b3906cb216f9a6df647483e6-60.png"},
          
          width: 60,
          height: 60
        }